import React, { useState } from "react";
import Calendar from "react-calendar";
import Card from "components/card";
import "react-calendar/dist/Calendar.css";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import "assets/css/MiniCalendar.css";

const MiniCalendar = () => {
  const [value, onChange] = useState(new Date());

  return (
    <Card extra="flex flex-col h-[420px] w-full rounded-[20px] p-4">
      
      {/* Header */}
      <div className="mb-3">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Calendar
        </h4>
      </div>

      {/* Calendar */}
      <div className="flex flex-1 items-center justify-center">
        <Calendar
          onChange={onChange}
          value={value}
          prevLabel={<MdChevronLeft className="h-6 w-6" />}
          nextLabel={<MdChevronRight className="h-6 w-6" />}
          view="month"
        />
      </div>

    </Card>
  );
};

export default MiniCalendar;